<template>
  <div>
    <user-view-form/>
    <user-probes/>
    <user-permissions v-if="user.role === 'super_admin'" />
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import UserViewForm from "../../components/user/UserViewForm";
import UserProbes from "../../components/user/UserProbes";
import UserPermissions from "@/components/user/UserPermissions";

export default {
  name: "UserView",
  components: {
    'user-view-form': UserViewForm,
    'user-probes': UserProbes,
    'user-permissions': UserPermissions
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  created() {
  },
  async mounted() {
    await this.fetchUser(this.$route.params.id)
    await this.fetchAllPermissions()
  },
  methods: {
    ...mapActions('user', ['fetchUser', 'fetchAllPermissions']),
  }
}
</script>

<style scoped>

</style>